import { SortingDirection } from "enums";
import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import { type GenericFiltersMap } from "../../../../../utils/filterUtils";
import { createFiltersSlice, type FiltersState } from "../../../../Application/slices/createFiltersSlice";
import { type VideoFiltersEnum } from "../../types/models";

export interface VideoFiltersState extends FiltersState<VideoFiltersEnum> {
  search?: string;
}

export const initialState: VideoFiltersState = {
  filterOptions: {} as GenericFiltersMap<VideoFiltersEnum>,
  appliedFilter: {} as GenericFiltersMap<VideoFiltersEnum>,
  isLoading: false,
  sortingColumnName: "Added",
  sortingDirection: SortingDirection.Descending,
};

const videoFiltersSlice = createFiltersSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Library,
    entity: ReducerEntityPrefixTypes.Videos,
    name: "overviewFilters",
  },
  initialState,
  reducers: {},
});

export const {
  setAppliedFilter,
  resetAppliedFilter,
  setIsLoading,
  setError,
  setFilterOptions,
  resetSearch,
  setSearch,
  setSortingDirection,
  setSortingColumnName,
} = videoFiltersSlice.actions;

export default videoFiltersSlice.reducer;
